import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useManagePackagesCountStatusReducer = () =>
  useSelector((state: ApplicationState) => state.managePackagesCountStatus);
